import React, { useState } from 'react';
import { login, register } from '../../auth/auth';
import LoginPopup from '../../auth/LoginPopup';
import ErrorPopup from '../../auth/errorPopup';
import { useNavigate } from 'react-router-dom';
import OTPAuthentication from './OTPAuthentication';


const LoginSignup = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isRegistering, setIsRegistering] = useState(false);
    const [user, setUser] = useState(null);
    const [name , setName] = useState('');
    const [confirmPassword , setConfirmPassword] = useState('');
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const navigate = useNavigate();

    const toggleTab = () => {
        setIsLogin((prev) => !prev);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!isLogin) {
                // setPassword(password===confirmPassword?password:'')
                const newUser = await register(email, password);
                setUser(newUser);
                console.log(newUser)
                setShowSuccessPopup(true);
            } else {
                const loggedInUser = await login(email, password);
                setUser(loggedInUser);
                setShowSuccessPopup(true);
                console.log('logged in user =>>>',loggedInUser)
            }
            setEmail('');
            setPassword('');
        } catch (error) {
            setShowErrorPopup(true);
            console.error("Authentication error:", error);
        }
    };
    const handleCloseSuccessPopup = () => {
        setShowSuccessPopup(false);
    };

    const handleCloseErrorPopup = () => {
        setShowErrorPopup(false);
    };
    const handleOnClick=()=>{
        navigate("/")

    }

    return (
        <div className="flex items-center justify-center min-h-screen bg-[#6C5F5B]">
            <div className="w-full max-w-md p-8 space-y-6 bg-[#4F4A45] rounded-lg shadow-md">
            <h1 className='bg-gradient-to-r from-blue-300 to-orange-300 text-transparent bg-clip-text text-3xl  font-bold font-serif'>PRAVASA</h1>

                <div className="flex justify-between">
                    <button
                        onClick={toggleTab}
                        className={`w-full py-2 font-semibold text-lg ${isLogin ? 'text-orange-600 border-b-2 border-orange-600' : 'text-gray-500'}`}
                    >
                        Login
                    </button>
                    <button
                        onClick={toggleTab}
                        className={`w-full py-2 font-semibold text-lg ${!isLogin ? 'text-orange -600 border-b-2 border-orange-600' : 'text-gray-500'}`}
                    >
                        Sign Up
                    </button>
                </div>

                {isLogin ? (
                    // <form onSubmit={handleSubmit}>
                    //     <div>
                    //         {/* <label className="block mb-1 text-sm font-semibold">Email</label> */}
                    //         <input
                    //             type="email"
                    //             placeholder="Email"
                    //             value={email}
                    //             onChange={(e) => setEmail(e.target.value)}
                    //             required
                    //             className="w-full px-4 py-2 border-b bg-transparent focus:outline-none focus:border-b-orange-500 "
                    //         />
                    //     </div>
                    //     <div>
                    //         {/* <label className="block mb-1 text-sm font-semibold">Password</label> */}
                    //         <input
                    //             type="password"
                    //             placeholder="Password"
                    //             value={password}
                    //             onChange={(e) => setPassword(e.target.value)}
                                
                    //             required
                    //             className="w-full px-4 py-2 border-b bg-transparent focus:outline-none  focus:border-b-orange-500"
                    //         />
                    //     </div>
                       
                    //     <button
                    //         type="submit"
                    //         className="w-full py-2 mt-4 text-white bg-orange-600 rounded-lg hover:bg-green-500 focus:outline-none"
                    //     >
                    //         Login
                    //     </button>
                    // </form>
                    <OTPAuthentication/>
                    
                ) : (
                    <form>
                        <div>
                            {/* <label className="block mb-1 text-sm font-semibold">Name</label> */}
                            <input
                                type="text"
                                placeholder='Name'
                                value={name}
                                onChange={(e)=>setName(e.target.value)}
                                required
                                className="w-full px-4 py-2 border-b bg-transparent focus:outline-none focus:border-b-orange-500"
                            />
                        </div>
                        <div>
                            {/* <label className="block mb-1 text-sm font-semibold">Email</label> */}
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full px-4 py-2 border-b bg-transparent focus:outline-none focus:border-b-orange-500"
                            />
                        </div>
                        <div>
                            {/* <label className="block mb-1 text-sm font-semibold">Password</label> */}
                            <input
                                type="password"
                                placeholder='Password'
                                value={password}
                                onChange={(e)=>setPassword(e.target.value)}
                                required
                                className="w-full px-4 py-2 border-b bg-transparent focus:outline-none focus:border-b-orange-500"
                            />
                        </div>
                        <div>
                            {/* <label className="block mb-1 text-sm font-semibold">Confirm Password</label> */}
                            <input
                                type="password"
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                className="w-full px-4 py-2 border-b bg-transparent focus:outline-none focus:border-b-orange-500"
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full py-2 mt-4 text-white bg-orange-600 rounded-lg hover:bg-green-500 focus:outline-none"
                        >
                            Sign Up
                        </button>
                    </form>
                )}
                <button
                type='submit'
                onClick={handleOnClick}
                className="w-full py-2 mt-4 text-blue-600 bg-transparent hover:bg-blue-500 focus:outline-none"
                >
                        Explore as guest!!
                </button>
            </div>
            {showSuccessPopup && <LoginPopup onClose={handleCloseSuccessPopup} />}
            {showErrorPopup && <ErrorPopup onClose={handleCloseErrorPopup} />}
        </div>
    );
};

export default LoginSignup
